export default __webpack_public_path__ + "static/media/4417.92cee829.png";